export default "__VITE_ASSET__1065b487__"